import { useState, useCallback, useEffect } from 'react';
import { useRouter } from 'next/router';
import Dynamic from '@base/Dynamic/Dynamic';
import { getQuizDetails } from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { TEST_PAGE_VIEWED } from '@constants/segment';
import Description from './Description/Description';
import Attachments from './Section/Attachments';
import AttemptSection from './Section/AttemptSection';
import Syllabus from './Section/Syllabus';
import { QuizStatusContext } from './Common/context';
import useQuizSegmentAnalytics from '../Common/useQuizSegmentAnalytics';

const Modals = Dynamic(() => import('./Modals'));

const TestDetails = () => {
  const { query } = useRouter();
  const { quizUID } = query;
  const segmentAnalytics = useQuizSegmentAnalytics();
  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));
  useEffect(() => {
    segmentAnalytics(TEST_PAGE_VIEWED, {
      is_invited: !!query?.referral_code,
      fpu_invite_code: query?.referral_code
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [status, setStatus] = useState(() => {
    const isInFuture = quizDetails.time_remaining > 0;
    const isLive =
      quizDetails.quiz_over_in > 0 && quizDetails.time_remaining <= 0;
    const isToday =
      new Date(quizDetails.start_time).toDateString() ===
      new Date().toDateString();

    return {
      isLive,
      isInFuture,
      isToday
    };
  });

  const handleIsLiveChange = useCallback((value) => {
    setStatus((data) => ({
      ...data,
      isInFuture: false,
      isLive: value
    }));
  }, []);

  const value = {
    status,
    handleIsLiveChange
  };

  return (
    <QuizStatusContext.Provider value={value}>
      <Description />
      <AttemptSection />
      <Syllabus />
      <Attachments />
      <Modals />
    </QuizStatusContext.Provider>
  );
};

export default TestDetails;
